module.exports = __webpack_public_path__ + "media/images/emblems/Coats_of_arms_of_None-737cd7dfa2e9c23909f4ad396a06c3d5.svg";